<div class="row">
  <div class="col-12">
    <div class="content-header">Digital Assets Form</div>
  </div>
</div>
<!-- Basic Inputs start -->
<section id="basic-input">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <!-- <div class="card-header">
                      <h4 class="card-title">Basic</h4>
                  </div> -->
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="col-md">
                <form [formGroup]="assetsForm">
                  <fieldset class="form-group">
                    <label for="name">Name</label>
                    <input type="text" class="form-control" formControlName="name" [(ngModel)]="assets_model.name"
                      id="name" placeholder="Enter name" [ngClass]="{
                          'is-invalid': assetsFormSubmitted && rf.name.invalid,
                          'is-valid': assetsFormSubmitted && !rf.name.invalid
                        }" required />
                    <div *ngIf="rf.name.touched &&
                          (rf.name.invalid || rf.name.errors?.required)
                        " class="help-block mt-1 text-danger">
                      <i class="ft-alert-circle align-middle"></i> Name is
                      required
                    </div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Type</label>
                    <ng-select [items]="type_list" bindLabel="name" bindValue="id" [closeOnSelect]="true" placeholder="Select Type"
                      [(ngModel)]="selected_type" [ngModelOptions]="{ standalone: true }" (change)="getTypeId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Gig Keywords</label>
                    <ng-select [items]="gig_tags_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                      placeholder="Select Gig Tags" [multiple]="true" [(ngModel)]="selected_gig_tag" [ngModelOptions]="{ standalone: true }"
                      (change)="getGigId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Domain</label>
                    <ng-select [items]="domain_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="true"
                      placeholder="Select Domain" [multiple]="true"  [(ngModel)]="selected_domain" [ngModelOptions]="{ standalone: true }"
                      (change)="getDomainId($event)">
                    </ng-select>
                  </fieldset>
                 
                  <fieldset class="form-group">
                    <label>Skill Keywords</label>
                    <div class="chip-container">
                      <span class="chip" *ngFor="let keyword of assets_model.skill_keywords; let i = index">
                        {{ keyword }}
                        <button class="close-btn" (click)="removeKeyword(i, 'skill')">x</button>
                      </span>
                      <div class="input-group">
                        <input #skillInput type="text"  (keydown.enter)="$event.preventDefault()" class="form-control border-0" placeholder="Add a skill" />
                        <button *ngIf="skillInput.value" class="btn btn-primary m-1" (click)="addKeyword(skillInput.value, 'skill'); skillInput.value=''">Add</button>
                      </div>
                    </div>
                  </fieldset>
                  
                  <fieldset class="form-group">
                    <label>Feature Keywords</label>
                    <div class="chip-container">
                      <span class="chip" *ngFor="let keyword of assets_model.features_keywords; let i = index">
                        {{ keyword }}
                        <button class="close-btn" (click)="removeKeyword(i, 'feature')">x</button>
                      </span>
                      <div class="input-group">
                        <input #featureInput type="text"  (keydown.enter)="$event.preventDefault()" class="form-control border-0" placeholder="Add a feature" />
                        <button *ngIf="featureInput.value" class="btn btn-primary m-1" (click)="addKeyword(featureInput.value, 'feature'); featureInput.value=''">Add</button>
                      </div>
                    </div>
                  </fieldset>
                  
                  <fieldset class="form-group">
                    <label>Project Keywords</label>
                    <div class="chip-container">
                      <span class="chip" *ngFor="let keyword of assets_model.projects_keywords; let i = index">
                        {{ keyword }}
                        <button class="close-btn" (click)="removeKeyword(i, 'project')">x</button>
                      </span>
                      <div class="input-group">
                        <input #projectInput type="text"  (keydown.enter)="$event.preventDefault()" class="form-control border-0" placeholder="Add a project" />
                        <button *ngIf="projectInput.value" class="btn btn-primary m-1" (click)="addKeyword(projectInput.value, 'project'); projectInput.value=''">Add</button>
                      </div>
                    </div>
                  </fieldset>
                  
                  
                  <!-- <fieldset class="form-group">
                    <label>Skills</label>
                    <ng-select [items]="skills_tag_List" bindLabel="displayname" bindValue="_id" #skills="ngModel"
                      [multiple]="true" [closeOnSelect]="false" placeholder="Select Skill" [(ngModel)]="selected_skill"
                      [ngModelOptions]="{ standalone: true }" (change)="getSkillTagsId($event)">
                    </ng-select>
                  </fieldset>
                  <fieldset class="form-group">
                    <label>Refrences</label>
                    <ng-select [items]="referenceList" bindLabel="name" [multiple]="true" [closeOnSelect]="true"
                      bindValue="_id" placeholder="Select References" [(ngModel)]="selectedRef"
                      [ngModelOptions]="{ standalone: true }" (change)="getRefId($event)">
                      <ng-template ng-header-tmp>
                        <div class="btn btn-link" (click)="openModal(myModal)">
                          Add New Reference
                        </div>
                      </ng-template>
                      <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.name }}</span><span>&nbsp;&nbsp;&nbsp;</span>
                        <i *ngIf="item.id === selectedItemId && item.assets_id" class="fa fa-edit"
                          (click)="editItem(item,myModal2)"></i>&nbsp;&nbsp;
                        <i *ngIf="item.id === selectedItemId && item.assets_id" class="fa fa-trash"
                          (click)="confirmDelete(item._id)"></i>
                      </ng-template>
                    </ng-select>
                  </fieldset> -->
                  
                </form>
              </div>
              <div class="col-md">
                <form [formGroup]="assetsForm">
                  
                  <fieldset class="form-group">
                    <label for="notes">notes</label>
                      <quill-editor 
                        (onEditorCreated)="setFocus($event)" 
                        (onContentChanged)="notes($event)" 
                        [(ngModel)]="updateNotes"  [ngModelOptions]="{standalone: true}">
                      </quill-editor>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="admin_notes">admin notes</label>
                      <quill-editor 
                        (onEditorCreated)="setFocus($event)" 
                        (onContentChanged)="adminNotes($event)" 
                        [(ngModel)]="updateAdminNotes"  [ngModelOptions]="{standalone: true}">
                      </quill-editor>
                  </fieldset>
                </form>
              </div>
            </div>
            <!-- <div class="col-12">
              <fieldset>
                <label>Gig Keywords</label>
                <ng-select [items]="gig_tags_list" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false" placeholder="Select Type" [multiple]="true" [(ngModel)]="selected_gig_tag" [ngModelOptions]="{ standalone: true }" (change)="getGigId($event)">
                </ng-select>
              </fieldset>
            </div> -->
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-center my-3">
              <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">
                Submit
              </button>
              <button type="reset" class="btn btn-secondary" (click)="back()">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-------------- Add Reference Popup ------------------------------------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Add Reference</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="referenceForm">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" [(ngModel)]="reference_model.name">
        </div>
        <div class="form-group">
          <label>Link</label>
          <input type="text" class="form-control" formControlName="links" [(ngModel)]="reference_model.links">
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" [(ngModel)]="reference_model.description"
            name="notes" id="notes" cols="30" rows="2"></textarea>
        </div>
        <div class="form-group">
          <label>Notes</label>
          <textarea class="form-control" formControlName="notes" [(ngModel)]="reference_model.notes" name="notes"
            id="notes" cols="30" rows="2"></textarea>
        </div>
        <div class="form-group">
          <label>Admin Notes</label>
          <textarea class="form-control" formControlName="admin_notes" [(ngModel)]="reference_model.admin_notes"
            name="notes" id="notes" cols="30" rows="2"></textarea>
        </div>
      </form>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="submitRef()">Submit</button>
    </div>
  </ng-template>
</div>
<!-------------- Edit Reference Popup ------------------------------------------->
<div>
  <ng-template #myModal2 let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Update Reference</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="referenceForm">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" [(ngModel)]="reference_model.name"
            [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group">
          <label>Link</label>
          <input type="text" class="form-control" [(ngModel)]="reference_model.links"
            [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" [(ngModel)]="reference_model.description" [ngModelOptions]="{standalone: true}"
            name="notes" id="notes" cols="30" rows="2"></textarea>
        </div>
        <div class="form-group">
          <label>Notes</label>
          <textarea class="form-control" [(ngModel)]="reference_model.notes" [ngModelOptions]="{standalone: true}"
            name="notes" id="notes" cols="30" rows="2"></textarea>
        </div>
        <div class="form-group">
          <label>Admin Notes</label>
          <textarea class="form-control" [(ngModel)]="reference_model.admin_notes" [ngModelOptions]="{standalone: true}"
            name="notes" id="notes" cols="30" rows="2"></textarea>
        </div>
      </form>

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="updateRef()">Update</button>
    </div>
  </ng-template>
</div>